import { AFFILIATES_RADIO_VALUES } from '../../../constants/affiliates';

export const addAffiliatesDataAdapter = ({ branded, ...state }) => ({
    branded: branded === AFFILIATES_RADIO_VALUES.BRANDED,
    ...state
});
